import { LevelData } from '../level-data';

export const level20: LevelData = {
    name: 'Whispertrail Master',
    timeLimit: 120,
    track: [
        '-------',
        '-------',
        '---B---',
        '-------',
        '--   --',
        '-------',
        '  ---  ',
        '-------',
        '--   --',
        '-------',
        '---B---',
        '-------',
        '  ---  ',
        '-------',
        '--   --',
        '-------',
        '---S---',
        '-------',
        '--   --',
        '-------',
        '  ---  ',
        '-------',
        '--   --',
        '-------',
        '---B---',
        '-------',
        '       ',
        '       ',
        '       ',
        '-------',
        '-------',
        '--   --',
        '-------',
        '---B---',
        '-------',
        '  ---  ',
        '-------',
        '--   --',
        '-------',
        '  ---  ',
        '-------',
        '--   --',
        '-------',
        '---B---',
        '-------',
        '  ---  ',
        '-------',
        '--   --',
        '-------',
        '---S---',
        '-------',
        '--   --',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        'FFFFFFF',
    ],
};
